/**
 * GroupPriceChips — Sprint R1
 *
 * 1x / 2x / 4x / 8x group shortcut chips. Each chip shows the group's total
 * price (n × ticket price, cents-based). Tapping a chip sets the quantity —
 * it never bypasses reserved-seat selection, hold rules, or checkout
 * validation (those all key off the resulting quantity).
 */
import React from "react";
import { centsToAUD } from "../lib/events";

const MULTIPLES = [1, 2, 4, 8];

export default function GroupPriceChips({
  priceCents = 0,
  max = 0,
  value = 0,
  onPick,
  testIdPrefix = "group-chip",
}) {
  if (max <= 0) return null;
  return (
    <div className="mt-2 flex flex-wrap gap-1.5" data-testid={`${testIdPrefix}-row`}>
      {MULTIPLES.map((n) => {
        const disabled = n > max;
        const active = value === n;
        const total = n * priceCents;
        return (
          <button
            key={n}
            type="button"
            disabled={disabled}
            aria-pressed={active}
            aria-label={`${n} tickets for ${total === 0 ? "free" : centsToAUD(total)}`}
            onClick={() => !disabled && onPick?.(n)}
            data-testid={`${testIdPrefix}-${n}`}
            className={
              "inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-sm border text-[11px] transition-colors " +
              (active
                ? "bg-[var(--gt-accent)] text-white border-[var(--gt-accent)]"
                : disabled
                ? "bg-white border-[var(--gt-line)] text-[var(--gt-ink-3)] opacity-50 cursor-not-allowed"
                : "bg-white border-[var(--gt-line)] hover:border-[var(--gt-ink)]")
            }
          >
            <span className="font-bold">{n}×</span>
            <span className="font-mono" data-testid={`${testIdPrefix}-${n}-total`}>
              {total === 0 ? "Free" : centsToAUD(total)}
            </span>
          </button>
        );
      })}
    </div>
  );
}
